import { Currency } from '../enum/currency'
import {
  objectSchema,
  optionalTolerant,
  tolerantArray,
  tolerantEnum,
} from '../../_utils/fcdc-v2'
import * as z from 'zod'

export const durationSchema = objectSchema({
  secs: optionalTolerant(z.number()),
  nanos: optionalTolerant(z.number()),
})

export const priceSchema = objectSchema({
  currency: tolerantEnum(Currency),
  amount: optionalTolerant(z.union([z.string(), z.number()])),
})

export const visualProfileSchema = objectSchema({
  logoUrl: optionalTolerant(z.string()),
  backgroundColor: optionalTolerant(z.string()),
  primaryColor: optionalTolerant(z.string()),
  secondaryColor: optionalTolerant(z.string()),
})

export const rateSchema = objectSchema({
  priceCategoryName: optionalTolerant(z.string()),
  priceCategoryId: optionalTolerant(z.string()),
  currency: tolerantEnum(Currency),
  pricePerAllocatedHour: optionalTolerant(z.string()),
  pricePerUnallocatedHour: optionalTolerant(z.string()),
  pricePerRollingHour: optionalTolerant(z.string()),
})

export const gracePeriodSchema = objectSchema({
  duration: optionalTolerant(durationSchema),
  maxUnlocks: optionalTolerant(z.number()),
  usedUnlocks: optionalTolerant(z.number()),
})

export const priceCapBlockSchema = objectSchema({
  priceCategoryId: optionalTolerant(z.string()),
  length: optionalTolerant(durationSchema),
  priceCap: optionalTolerant(priceSchema),
  repeating: optionalTolerant(z.boolean()),
})

export const lengthPriceCapSchema = objectSchema({
  blocks: optionalTolerant(tolerantArray(priceCapBlockSchema)),
})

export const priceSlotSchema = objectSchema({
  priceCategoryId: optionalTolerant(z.string()),
  length: optionalTolerant(durationSchema),
  price: optionalTolerant(priceSchema),
})

export const priceSlotsSchema = objectSchema({
  slots: optionalTolerant(tolerantArray(priceSlotSchema)),
  overflowSlot: optionalTolerant(tolerantArray(priceSlotSchema)),
})

export const availablePayloadSchema = objectSchema({
  lockerRates: optionalTolerant(tolerantArray(rateSchema)),
})

export const serviceFeeSchema = objectSchema({
  price: optionalTolerant(priceSchema),
})
